import { Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { SignupComponent } from './authentication/signup/signup.component';
import { ShopComponent } from './shop/shop.component';
import { pagesRoutes } from './pages/pages.routes';
import { settingsRoutes } from './settings/settings.routes';
import { authGuard, checkAbandoneOrNoAddressdUser, maintenanceGuard, checkMembershipPermissions, checkNoPaymentMethodUser, maintenanceOffGuard, preventForAbandoneOrNoAddressdUser, getQueryParamsGuardAndRedirect } from './shared/guards/auth-guard.guard';
import { TermsAndConditionsComponent } from './authentication/signup/terms-and-conditions/terms-and-conditions.component';
import { accountRecoveryRoutes } from './authentication/account-recovery/account-recovery.routes';
import { FavProductsComponent } from './fav-products/fav-products.component';
import { BuyAgainProductsComponent } from './buy-again-products/buy-again-products.component';
import { CustomBoxComponent } from './shared/custom-box/custom-box.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { PrivacyPolicyComponent } from './shared/privacy-policy/privacy-policy.component';
import { RedirectComponent } from './shared/redirect/redirect.component';
import { EcommerceAdminComponent } from './authentication/ecommerce-admin/ecommerce-admin.component';
import { ShopOrProductComponent } from './shop/shop-or-product/shop-or-product.component';
import { productsResolver } from './resolvers/shop.resolver';
import { canDeactivateGuard } from './shared/guards/deactivate/can-deactivate.guard';
import { SideCheckoutComponent } from './side-checkout/side-checkout.component';

export const routes: Routes = [
  {
    path: 'maintenance',
    title: 'Maintenance',
    component: MaintenanceComponent,
    canActivate: [maintenanceOffGuard]
  },
  {
    path: 'ecommerce-admin/:token',
    title: 'Ecommerce Admin',
    component: EcommerceAdminComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    title: 'Log In',
    component: LoginComponent,
    canActivate: [maintenanceGuard, authGuard]
  },
  {
    path: 'signup',
    title: 'Sign Up',
    component: SignupComponent,
    canActivate: [maintenanceGuard]
  },
  ...pagesRoutes,
  ...settingsRoutes,
  ...accountRecoveryRoutes,
  {
    path: 'shop',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    canActivateChild: [maintenanceGuard],
  },
  {
    path: 'shop/custom-box/:bundleEditionType/:productId',
    title: 'Shop Custom Box',
    component: CustomBoxComponent,
    pathMatch: 'full',
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'shop/:category',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
  },
  {
    path: 'shop/:category/:subcategory',
    component: ShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
  },
  // This route is used for both, product detail or subcategory son navigation:
  {
    path: 'shop/:category/:subcategory/:slug',
    component: ShopOrProductComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    resolve: {
      data: productsResolver
    }
  },
  {
    path: 'favorites',
    title: 'Favorites',
    component: FavProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'buy-again',
    title: 'Buy again',
    component: BuyAgainProductsComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'order',
    title: 'Order',
    component: SideCheckoutComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, preventForAbandoneOrNoAddressdUser],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions',
    component: TermsAndConditionsComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'privacy-policy',
    title: 'Privacy Policy',
    component: PrivacyPolicyComponent,
    canActivate: [maintenanceGuard]
  },

  {
    path: 'order/custom-box/:bundleEditionType',
    title: 'Order Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'order/custom-box/:bundleEditionType/:productId',
    title: 'Order Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'product/custom-box/:bundleEditionType/:productId',
    title: 'Product Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'signup/custom-box/:bundleEditionType/:productId',
    title: 'Sign Up Custom Box',
    component: CustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  { path: '**', component: RedirectComponent, canActivate: [getQueryParamsGuardAndRedirect] },
];
